/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import "./Stamreeks.scss";
import React from "react";
import { GenealogySource, Parent } from "./Genealogy/types";
import { Stamreeks } from "./Stamreeks";
import { getSources } from "./Genealogy/BekkersSources";
import { getBekkersParents } from "./Stamreeksen/bekkers";

export class StamreeksBekkers extends React.Component<{}, { parents: Parent[] }> {
  sources: GenealogySource[] = [];
  constructor(props: {}) {
    super(props);
    this.initialize();
  }

  initialize = () => {
    getSources().then((sources) => {
      this.sources = sources;
      this.setState({ parents: getBekkersParents(sources) });
    });
  };

  render() {
    if (!this.sources || !this.state || !this.state.parents) return <div />;

    const content = () => (
      <div>
        <h1>Stamreeks "Bekkers"</h1>
        <p>Mijn moeder was een 'Bekkers', daarom ben ik in deze stamreeks op zoek gegaan naar de mannelijke 'Bekkers' lijn.</p>
      </div>
    );

    return <Stamreeks content={content()} sources={this.sources} parents={this.state.parents} />;
  }
}
